  query getCountryTotals(
    $clientId: ID
    $projectId: ID
    $productIds: [ID]
    $startDate: AWSDateTime
    $endDate: AWSDateTime
  ) {
    countryTotals: SalesAnalyticsGetCountryTotals(
      startDate: $startDate
      endDate: $endDate
      clientId: $clientId
      projectId: $projectId
      productIds: $productIds
      productView: BUNDLE
    ) {
      country
      quantity
      sales
    }
  }